module.exports = __webpack_public_path__ + "img/mobileTheme-upgrade.1b5d9ab6.svg";